import React, { useEffect } from 'react';
import * as Yup from 'yup';
import { Field, Form, Formik, useFormik } from 'formik';

import {
  Button,
  Box,
  Grid,
  Typography,
  Chip,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormHelperText,
  FormControl,
  FormGroup,
  Checkbox,
} from '@mui/material';
import InputField from 'components/Input-Field/input-field';
import SelectField from 'components/Select-Field/select-field';
import { DEFAULT_PERMISSIONS_BY_ROLE, TENANT_USER_ROLES, USER_PERMISSIONS } from 'utils/constant.js';
import FormElements from 'components/FormElements';

const EditUserForm = ({ user, isUpdatingUserRole, updateFormHandler }) => {

  const userValidationSchema = Yup.object().shape({
    email: Yup.string().email('Must be a valid email').max(100).required('Email is required'),
    firstName: Yup.string().min(2).max(50).required('FirstName is required.'),
    lastName: Yup.string().min(2).max(50).required('LastName is required.'),
  });

  return (
    <Formik
      initialValues={{ ...user, permission: user.permission }}
      validationSchema={userValidationSchema}
      enableReinitialize
      onSubmit={(values) => {
        const trimmed_data = {};
        Object.keys(values).forEach(key => trimmed_data[key] = typeof (values[key]) === 'string' ? values[key].trim() : values[key]);
        trimmed_data.role = new Array(trimmed_data.role);
        updateFormHandler(trimmed_data);
      }}
    >
      {({ values, setFieldValue }) => {
        useEffect(() => {
          if (values.role && DEFAULT_PERMISSIONS_BY_ROLE[values.role]) {
            setFieldValue('permission', DEFAULT_PERMISSIONS_BY_ROLE[values.role]);
          }
        }, [values.role, setFieldValue]);
        return (
          <Form>
            <Grid container spacing={2}>
              <Grid size={{ xs: 12 }}>
                <FormElements.SectionTitle title='User Information' />
              </Grid>              
              <Grid size={{xs: 4}}>
                <Field name='email'>
                  {({ field, meta }) => (
                    <InputField
                      fullWidth
                      label='Enter User Email'
                      variant='outlined'
                      margin='dense'
                      {...field}
                      error={meta.touched && Boolean(meta.error)}
                      helperText={meta.touched && meta.error}
                    />
                  )
                  }
                </Field>
              </Grid>
              <Grid size={{xs: 4}}>
                <Field name='firstName'>
                  {({ field, meta }) => (
                    <InputField
                      fullWidth
                      label='Enter user First Name'
                      variant='outlined'
                      margin='dense'
                      {...field}
                      error={meta.touched && Boolean(meta.error)}
                      helperText={meta.touched && meta.error}
                    />
                  )}
                </Field>
              </Grid>
              <Grid size={{xs: 4}}>
                <Field name='lastName'>
                  {({ field, meta }) => (
                    <InputField
                      fullWidth
                      label='Enter user Last Name'
                      variant='outlined'
                      margin='dense'
                      {...field}
                      error={meta.touched && Boolean(meta.error)}
                      helperText={meta.touched && meta.error}
                    />
                  )}
                </Field>
              </Grid>
              {isUpdatingUserRole &&
                <Grid container spacing={2}>
                  <Grid size={{ xs: 12 }}>
                    <FormElements.SectionTitle title='Roles & Permissions' />
                  </Grid>
                  <Grid item xs={8} style={{ display: 'flex' }}>
                    <Typography variant='subtitle1' sx={{ fontWeight: 600, margin: 'auto 10px' }}>{'Select User Role'}</Typography>
                    <Field name='role'>
                      {({ field, meta }) => (
                        <FormControl
                          component='fieldset'
                          error={meta.touched && Boolean(meta.error)}
                        >
                          <RadioGroup
                            row
                            {...field}
                          >
                            {TENANT_USER_ROLES.map((user_role) => (
                              <FormControlLabel
                                key={user_role}
                                value={user_role}
                                control={<Radio size='small' />}
                                label={user_role}
                                labelPlacement='end'
                              />
                            ))}
                          </RadioGroup>
                          {meta.touched && meta.error && (
                            <FormHelperText>{meta.error}</FormHelperText>
                          )}
                        </FormControl>
                      )}
                    </Field>
                  </Grid>
                  <Grid container>
                    {USER_PERMISSIONS.map((item) => (
                      // const SELECTED_PERMISSIONS = item.options.filter(opt => values.permission.includes(opt.value));
                      <Grid size={{ xs: 8 }}>
                        <Box display={'flex'}>
                          <Typography color='caption' style={{ margin: 'auto', fontWeight: 600 }}>{item.component}</Typography>
                          {/* <FormControl required component='fieldset'> */}
                          <FormGroup row>
                            {item.options.map((permission, idx) => (
                              <Field
                                key={`${permission}-${idx}`}
                                type='checkbox'
                                name='permission'
                                value={permission.value}
                              >
                                {({ field }) => {
                                  const isChecked = values.permission.includes(permission.value);
                                  return (
                                    <FormControlLabel
                                      labelPlacement='end'
                                      label={permission.label.toUpperCase()}
                                      control={
                                        <Checkbox
                                          size='small'
                                          name='permission'
                                          checked={isChecked}
                                          value={permission.value}
                                          onChange={e => {
                                            const { checked, value } = e.target;
                                            const currentPermissions = values.permission;
                                            const updatedPermissions = checked
                                              ? [...currentPermissions, value]
                                              : currentPermissions.filter((v) => v !== value);

                                            setFieldValue('permission', updatedPermissions);
                                          }}
                                        />
                                      }
                                    />
                                  )
                                }}
                              </Field>
                            ))}
                          </FormGroup>
                          {/* </FormControl> */}
                        </Box>
                      </Grid>
                    ))}
                  </Grid>
                </Grid>
              }
            </Grid>
            <Box mt={5}
              display='flex'
              justifyContent='flex-end'
              p={2}
            >
              <Button
                type='submit'
                variant='contained'
                color='primary'
              >
                Update User
              </Button>
              </Box>            
          </Form>
        )
      }}
    </Formik>
  );
};
export default EditUserForm;